<template>
  <div :class="['menu-wrap', collapse ? 'menu-collapse' : '']"
    @mouseenter="handleCollapseMenu(false)"
    @mouseleave="handleCollapseMenu(true)"
  >
    <div class="menu-header" v-if="isServicePage">
      <div class="backmap">
        <router-link to="/app/myapp">
          &lt; 返回
        </router-link>
      </div>
      <el-tooltip class="item" effect="dark" :content="getAppName || '尚未设置'" placement="right">
        <div class="ellipsis">{{getAppName || '尚未设置'}}</div>
      </el-tooltip>
    </div>
    <div class="menu-content">
      <el-menu :default-active="getMenu" :collapse="collapse" :unique-opened="true">
        <template v-for="(menuItem, index) in menuData">
          <el-submenu
            v-if="menuItem.submenu && menuItem.submenu.length > 0"
            :index="index + ''"
            :key="index + ''">
            <template slot="title">
              <div style="overflow: hidden">
                <svg class="icon icon-business">
                  <use :xlink:href="menuItem.icon"></use>
                </svg>{{menuItem.title}}
              </div>
            </template>
            <template v-for="submenuItem in menuItem.submenu">
              <router-link v-if="!submenuItem.external" :to="submenuItem.path" :key="submenuItem.key">
                <el-menu-item :index="submenuItem.key" >
                  <div class="submenuItem-title">{{submenuItem.title}}</div>
                </el-menu-item>
              </router-link>
              <a v-else target="_blank" :href="submenuItem.path" :key="submenuItem.key">
                <el-menu-item :index="submenuItem.key" >
                  <div>{{submenuItem.title}}</div>
                </el-menu-item>
              </a>
            </template>
          </el-submenu>
          <template v-else>
            <router-link class="leaf-submenu" v-if="!menuItem.external" :to="menuItem.path" :key="menuItem.key || index + ''">
              <el-menu-item :index="menuItem.key || index + ''">
                <div style="overflow: hidden">
                  <svg class="icon icon-business">
                    <use :xlink:href="menuItem.icon"></use>
                  </svg>{{menuItem.title}}
                </div>
              </el-menu-item>
            </router-link>
            <a v-else class="leaf-submenu" target="_blank" :href="menuItem.path" :key="menuItem.key || index + ''">
              <el-menu-item :index="menuItem.key || index + ''">
                <div style="overflow: hidden">
                  <svg class="icon icon-business">
                    <use :xlink:href="menuItem.icon"></use>
                  </svg>{{menuItem.title}}
                </div>
              </el-menu-item>
            </a>
          </template>
        </template>
        <router-link v-if="!collapse && getHistoryServices.length > 0" to="/services/history">
          <div class="to-history">历史服务列表</div>
        </router-link>
      </el-menu>
    </div>
  </div>
</template>

<script>
import api from 'api/system'
import { mapGetters } from 'vuex'
import store from 'store'
import menuData from 'constant/menu'
import 'config'
export default {
  name: 'SideBar',
  data () {
    return {
      menuData,
      isCollapseMenu: true
    }
  },
  mounted() {
    this.$emit('collapse', this.collapse)
  },
  methods: {
    // 主菜单折叠事件
    handleCollapseMenu(value) {
      this.timeout && clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.isCollapseMenu = value;
        // this.$emit('collapse', this.collapse)
      }, 250)
    },
  },
  computed: {
    aiuiUrl() {
      return Url[Mode].aiuiUrl
    },
    baseUrl() {
      return Url[Mode].baseUrl
    },
    isServicePage() {
      return this.$route.path.split('/')[1] === 'services'
    },
    isMapPage() {
      return this.$route.path === '/app/myapp'
    },
    collapse () {
      return !this.isServicePage && this.isCollapseMenu
    },
    ...mapGetters([
      'getMenu',
      'getAppId',
      'getAppName',
      'getHistoryServices',
    ])
  },
  watch: {
    'getAppId' (to, from) {
      // 默认APPID变化时重新加载历史服务菜单
      api.getOfflineService(to).then(({data}) => {
        store.dispatch('setHistoryServices', data)
      })
    },
    collapse (to, from) {
      this.$emit('collapse', to)
    }
  },
}
</script>

<style lang="stylus">
@import '~styl/mixins'
.menu-wrap
  display flex
  flex-direction column
  background-color #fff
  position absolute
  left 0
  top 0
  bottom 0
  width 2.1rem
  border-right 1px solid #e5eaf0
  overflow hidden
  transition width .3s ease-in-out
  z-index 2
  &.menu-collapse
    width .66rem
    overflow hidden
    .menu-header
      height 0
  .el-menu
    background-color #fff
    width: .66rem;
    &:not(.el-menu--collapse) { width: 2.1rem; }
    .el-menu-item
      color #333
      &.is-active
        position relative
        color #3f84e2
        font-weight bold
        background-color #f7f7f7
        &::before
          content ''
          position absolute
          width .04rem
          top 0
          bottom 0
          left 0
          background-color #3f84e2
        .icon
          color #3f84e2
  .menu-header
    display flex
    flex-direction column
    justify-content center
    height .8rem
    font-size .18rem
    font-weight bold
    padding 0 .25rem
    color #333333
    border-bottom 1px solid #e5eaf0
    overflow hidden
    transition height .3s ease-in-out
    white-space nowrap
    .backmap
      font-size .14rem
      font-weight normal
      color #999
      margin-bottom .1rem
      a
        color #999999
    .ellipsis
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
  .menu-content
    flex 1
    overflow-y auto
    overflow-x hidden
    &::-webkit-scrollbar
      display none
    .el-submenu
      border-bottom 1px dashed #e5e5e5
      .el-icon-arrow-down:before
        color #9a9a9a
        font-size .14rem
  a.leaf-submenu
    display block
    border-bottom 1px dashed #e5e5e5
  .el-submenu > .el-submenu__title, .leaf-submenu > .el-menu-item
    overflow hidden
    font-size .16rem
    color #333
    height 68px
    line-height 68px
    .icon
      font-size .24rem
      position relative
      top -.02rem
      margin-right .15rem
  .el-submenu .el-menu-item:hover, .el-submenu__title:hover
    background-color #f7f7f7
  .to-history
    text-align center
    text-decoration underline
    height: 56px;
    line-height: 56px;
    background-color #eef1f6
    color #a0a0a0
    &:hover
     color #404040
</style>
<style lang="stylus" scoped>
  .submenuItem-title {
    display flex
    align-items center
    height 50px
    line-height 20px
    overflow hidden
    white-space break-spaces
    text-overflow ellipsis
  }
</style>



// WEBPACK FOOTER //
// app/components/SideBar/Main.vue